export default __webpack_public_path__ + "static/media/menuWholeEn2.3c013c04.png";